import styled from 'styled-components';

import { theme } from '../../global';

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainContentWrapper = styled.div`
  max-width: ${theme.content.max_width};
  width: 100%;
  min-height: calc(100vh - 108px - 104px);
  margin-top: 108px;

  .ant-notification-notice-wrapper {
    margin-top: 120px;

    @media (max-width: 1100px) {
      margin-top: ${theme.spacings.s64};
    }
  }

  .ant-notification
    .ant-notification-notice-wrapper
    .ant-notification-notice-message {
    font-size: 14px;
    font-weight: 500;
    color: ${theme.colors.green};
    text-align: center;
  }

  .ant-notification
    .ant-notification-notice-wrapper
    .ant-notification-notice-close {
    top: 16px;
  }

  .ant-notification
    .ant-notification-notice-wrapper
    .ant-notification-notice-icon {
    bottom: 14px;
  }

  .ant-notification
    .ant-notification-notice-wrapper
    .ant-notification-notice-close {
    inset-inline-end: 12px;
  }

  @media (max-width: 1100px) {
    min-height: calc(100vh - 72px - 196px);
    margin-top: 72px;
  }
`;
